import { Flex } from './layout';
import { Typography } from './typography';

export default function ReloadExtension() {
  return (
    <Flex
      direction='col'
      justify='center'
      align='center'
      gap='2xl'
      className='h-screen px-4'
      id='drumkit-content-view-root'
    >
      <Typography weight='bold' align='center'>
        A new version of Drumkit was installed.
      </Typography>
      <Typography variant='body-sm' align='center'>
        Refresh this tab to continue using Drumkit.
      </Typography>
    </Flex>
  );
}
